import { getDefaultStore } from "jotai";

import {
  activeSlotAtom,
  hangingProtocolActionsAtom,
  slotStateFamily,
} from "../../atoms/hangingProtocolAtoms";
import { registerCommand } from "./registry";

registerCommand("jumpToSlice", ({ slotId, sliceIndex }) => {
  const store = getDefaultStore();
  const targetSlotId = slotId ?? store.get(activeSlotAtom);
  const slot = store.get(slotStateFamily(targetSlotId));

  if (!slot.seriesId || slot.totalSlices === 0) {
    return { ok: false, error: "no-series" };
  }

  if (sliceIndex < 0 || sliceIndex >= slot.totalSlices) {
    return { ok: false, error: "out-of-range" };
  }

  store.set(hangingProtocolActionsAtom, {
    type: "CHANGE_SLICE",
    slotId: targetSlotId,
    sliceIndex,
  });

  return { ok: true };
});
